import { Spinner } from '@wartek-id/spinner'
import { Text } from '@wartek-id/text'

export const LoadingState = () => {
  return (
    <div className="flex flex-col items-center py-4">
      <Spinner />
      <Text className="mt-2">Memuat data</Text>
    </div>
  )
}

export const PopupLoadingState = ({ text }) => {
  return (
    <div className="bg-black/70 fixed h-screen w-screen inset-0 flex justify-center items-center z-20">
      <div className="bg-white rounded-[4px] p-4 flex flex-col items-center max-w-[200px]">
        <div className="p-3">
          <Spinner />
        </div>
        <Text className="mt-2">{text}</Text>
      </div>
    </div>
  )
}
